/* plantas finas — Versand-Fortschrittsbalken in der Warenkorb-Schublade

   Warum hier JavaScript und auf der Warenkorbseite Liquid?

   Die Warenkorbseite rendert Shopify serverseitig; dort steckt der Balken als
   Snippet in main-cart-footer.liquid und ist ohne JavaScript da. Die Schublade
   dagegen ist ohnehin eine reine JavaScript-Komponente — ohne JS laesst sie
   sich gar nicht oeffnen. Sie mit Liquid zu bestuecken haette bedeutet, die
   30 KB grosse Datei snippets/cart-drawer.liquid anzufassen; das Risiko steht
   in keinem Verhaeltnis. Beide Wege benutzen dieselben CSS-Klassen aus
   assets/pf-versandbalken.css, das Ergebnis sieht identisch aus.

   ================================================================
   ACHTUNG — DIE SCHWELLE STEHT AN ZWEI STELLEN
   ================================================================
   SCHWELLE unten ist eine Kopie der echten Versandbedingung aus
   Shopify Admin > Einstellungen > Versand und Zustellung > Zone Deutschland
   > Tarif "Standard" mit Bedingung "Bestellpreis ab 49,00 €".
   Derselbe Wert steht in snippets/pf-versandbalken.liquid.
   Aenderst du die Versandbedingung, aendere BEIDE Dateien mit — sonst
   verspricht der Warenkorb etwas, das der Checkout nicht einloest. */

(function () {
  'use strict';

  var SCHWELLE = 4900; // Cent

  var kachel = null;
  var letzteSignatur = null;
  var wartet = null;

  /* Schreibt Betraege so, wie Shopifys money-Filter es auf der Warenkorbseite
     tut — also "€19,10" und nicht "19,10 €". Stuende hier ein anderes Format,
     saehe derselbe Betrag in Schublade und Warenkorb unterschiedlich aus. */
  function euro(cent) {
    var zahl;
    try {
      zahl = (cent / 100).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      zahl = (cent / 100).toFixed(2).replace('.', ',');
    }
    return '€' + zahl;
  }

  function bauen() {
    var d = document.createElement('div');
    d.className = 'pf-vb';
    d.innerHTML =
      '<p class="pf-vb-text"></p>' +
      '<div class="pf-vb-bahn" role="progressbar" aria-valuemin="0" aria-valuemax="100"' +
      ' aria-label="Fortschritt zum kostenlosen Versand">' +
      '<span class="pf-vb-fuell"></span></div>' +
      '<p class="pf-vb-tipp" hidden></p>';
    return d;
  }

  /* Haengt die Kachel als erstes Element in den Fuss der Schublade.
     Dawn ersetzt bei jeder Mengenaenderung den gesamten Inhalt von
     .drawer__inner — die Kachel ist danach weg und wird hier neu gesetzt. */
  function einhaengen() {
    var fuss = document.querySelector('#CartDrawer .drawer__footer');
    if (!fuss) return false;
    if (!kachel) kachel = bauen();
    if (fuss.firstElementChild !== kachel) {
      fuss.insertBefore(kachel, fuss.firstChild);
    }
    return true;
  }

  function fuellen(warenkorb) {
    var stand = warenkorb.total_price || 0;
    var rest = SCHWELLE - stand;
    var prozent = Math.min(100, Math.round((stand * 100) / SCHWELLE));

    var einzeln = (warenkorb.items || []).some(function (p) {
      return p.quantity === 1;
    });

    /* Ohne diesen Vergleich entstuende eine Endlosschleife: Jede Schreibaktion
       im DOM loest den MutationObserver aus, der wieder hierher fuehrt.
       Aendert sich nichts, wird auch nichts geschrieben — und die Kette endet. */
    var signatur = stand + '|' + warenkorb.item_count + '|' + einzeln;
    if (signatur === letzteSignatur) return;
    letzteSignatur = signatur;

    var text = kachel.querySelector('.pf-vb-text');
    var bahn = kachel.querySelector('.pf-vb-bahn');
    var fuell = kachel.querySelector('.pf-vb-fuell');
    var tipp = kachel.querySelector('.pf-vb-tipp');

    if (rest > 0) {
      kachel.classList.remove('pf-vb--fertig');
      text.innerHTML =
        'Noch <strong>' + euro(rest) + '</strong> bis zum kostenlosen Versand';
    } else {
      kachel.classList.add('pf-vb--fertig');
      text.innerHTML =
        '<span class="pf-vb-haken" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" focusable="false">' +
        '<path d="M5 12.5l4.5 4.5L19 7.5"></path></svg></span>' +
        'Kostenloser Versand erreicht';
    }

    bahn.setAttribute('aria-valuenow', String(prozent));
    fuell.style.width = prozent + '%';

    if (rest > 0 && einzeln) {
      tipp.innerHTML =
        'Ein zweites Stück desselben Produkts bringt zusätzlich <strong>−10 %</strong>.';
      tipp.hidden = false;
    } else {
      tipp.hidden = true;
    }
  }

  function abraeumen() {
    letzteSignatur = null;
    if (kachel && kachel.parentElement) {
      kachel.parentElement.removeChild(kachel);
    }
  }

  function aktualisieren() {
    clearTimeout(wartet);
    wartet = setTimeout(function () {
      var pfad = (window.routes && window.routes.cart_url) || '/cart';
      fetch(pfad + '.js', { headers: { Accept: 'application/json' } })
        .then(function (a) {
          return a.json();
        })
        .then(function (warenkorb) {
          if (!warenkorb || !warenkorb.item_count) {
            abraeumen();
            return;
          }
          if (einhaengen()) fuellen(warenkorb);
        })
        .catch(function () {
          /* Netzfehler: lieber gar kein Balken als ein falscher */
        });
    }, 80);
  }

  function start() {
    var schublade = document.querySelector('cart-drawer');
    if (!schublade || typeof MutationObserver !== 'function') return;

    aktualisieren();

    new MutationObserver(aktualisieren).observe(schublade, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
